var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dis"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2058",
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F9B617"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Message_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4573 10C20.396 10 21.299 10.371 21.9633 11.0367C22.6283 11.701 23 12.597 23 13.535V19.065C23 21.018 21.411 22.6 19.4573 22.6H12.542C10.5883 22.6 9 21.018 9 19.065V13.535C9 11.582 10.5813 10 12.542 10H19.4573ZM20.5714 14.5778L20.6274 14.5218C20.7947 14.3188 20.7947 14.0248 20.6197 13.8218C20.5224 13.7175 20.3887 13.6538 20.2494 13.6398C20.1024 13.6321 19.9624 13.6818 19.8567 13.7798L16.7004 16.2998C16.2944 16.6365 15.7127 16.6365 15.3004 16.2998L12.1504 13.7798C11.9327 13.6188 11.6317 13.6398 11.4504 13.8288C11.2614 14.0178 11.2404 14.3188 11.4007 14.5288L11.4924 14.6198L14.6774 17.1048C15.0694 17.4128 15.5447 17.5808 16.0424 17.5808C16.5387 17.5808 17.0224 17.4128 17.4137 17.1048L20.5714 14.5778Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7e9b9524da0ebd0e2a674e3a9bc27843.svg";
export { ForwardRef as ReactComponent };